import { IconButton, type IconButtonProps, Snackbar as MUISnackbar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { forwardRef } from "react";

export const Snackbar = MUISnackbar;

export const SnackbarCloseButton = forwardRef<HTMLButtonElement, Omit<IconButtonProps, "children">>((props, ref) => (
  <IconButton size="small" aria-label="close" color="inherit" {...props} ref={ref}>
    <CloseIcon fontSize="medium" />
  </IconButton>
));
